import { deprecatedWidgetIds } from '../constants/deprecatedWidgetIds'
import { DeprecatedWidgetId } from '../types/deprecatedWidgetId'
import { WidgetId } from '../types/widgetId'

export const isDeprecatedWidgetId = (value: DeprecatedWidgetId | WidgetId): value is DeprecatedWidgetId => {
  return deprecatedWidgetIds.includes(value as DeprecatedWidgetId)
}
